import React from "react";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { withShowIf } from "../../with-show-if/with-show-If.component";
import { DrawerControlButtonProps } from "../types/drawer-control-button.props";
import { HostContainer } from "./drawer-collapse-button.styles";

export const DrawerCollapseButton = withShowIf((props: DrawerControlButtonProps) => (
  <HostContainer variant="filled" onClick={props.onClick}>
    <ChevronRightIcon />
  </HostContainer>
));
